import { api, buildQueryParams, URLs } from '@/libs/api'
import type {
  ApiResponse,
  ProductInventoryItem,
  ProductInventoryItemListData,
  ProductInventoryItemParams,
} from '@/libs/interfaces'
import { IS_MOCK_MODE } from '@/libs/mocks/config'
import { dashboardApiMock } from '@/libs/mocks/handlers/dashboard'

const dashboardApiReal = {
  getKPITotalBilled: (
    orgID: string,
    storeID?: string,
    from?: string,
  ): Promise<ApiResponse<{ data: { totalBilled: number } }>> =>
    api
      .get<{ data: { totalBilled: number } }>(URLs.Dashboard.totalBilled(orgID), {
        ...(storeID && { storeID }),
        ...(from && { from }),
      })
      .then((response) => response),

  getKPITotalBookings: (
    orgID: string,
    storeID?: string,
    from?: string,
  ): Promise<ApiResponse<{ data: { totalBookings: number } }>> =>
    api
      .get<{ data: { totalBookings: number } }>(URLs.Dashboard.totalBookings(orgID), {
        ...(storeID && { storeID }),
        ...(from && { from }),
      })
      .then((response) => response),

  getKPITotalEmployees: (
    orgID: string,
    storeID?: string,
    from?: string,
  ): Promise<ApiResponse<{ data: { totalEmployees: number } }>> =>
    api
      .get<{ data: { totalEmployees: number } }>(URLs.Dashboard.totalEmployees(orgID), {
        ...(storeID && { storeID }),
        ...(from && { from }),
      })
      .then((response) => response),

  getKPITotalServices: (
    orgID: string,
    storeID?: string,
    from?: string,
  ): Promise<ApiResponse<{ data: { totalServices: number } }>> =>
    api
      .get<{ data: { totalServices: number } }>(URLs.Dashboard.totalServices(orgID), {
        ...(storeID && { storeID }),
        ...(from && { from }),
      })
      .then((response) => response),

  getinventoryStatus: (params: ProductInventoryItemParams): Promise<ProductInventoryItem[]> => {
    const { ...queryParams } = params
    const query = buildQueryParams(queryParams)
    return api
      .get<
        ApiResponse<ProductInventoryItemListData>
      >(URLs.Dashboard.productInventory(params.orgID, query))
      .then((response) => response.data.data.inventory)
  },
}

export const dashboardApi: typeof dashboardApiReal = IS_MOCK_MODE
  ? dashboardApiMock
  : dashboardApiReal
